<template>
  <div>
    <app-header>
      <template #title>
        <h1 class="d-inline me-4">Stack</h1>
      </template>
      <template v-slot:actions></template>
    </app-header>

    <ul id="horizontal-nav" class="nav nav-horizontal">
      <router-link
        tag="li"
        class="nav-item"
        :to="{ name: 'stacks.overview' }"
      >
        <a class="nav-link">Overview</a>
      </router-link>
       <router-link
        tag="li"
        class="nav-item"
        :to="{ name: 'stacks.aws-accounts' }"
      >
        <a class="nav-link">AWS Accounts</a>
      </router-link>
      <router-link
        tag="li"
        class="nav-item"
        :to="{ name: 'stacks.invoices' }"
      >
        <a class="nav-link">Invoices</a>
      </router-link>
    </ul>

    <router-view v-if="loaded" @refresh="loadData"></router-view>
  </div>
</template>

<script>
import { mapState, mapActions } from "vuex";
import { cloneDeep } from "lodash";
import { helperMethods } from "vx/modules/clients";

export default {
  data: function () {
    return {
      loaded: false
    };
  },
  computed: {
    ...mapState("stack", {
      stack: "single",
    }),
  },

  mounted: function () {
    this.loadData()
  },

  methods: {
    ...helperMethods,
    ...mapActions("stack", {
      getStack: "getSingle"
    }),

    loadData() {
       this.getStack(this.$route.params.stack_id).then(() => {
        this.loaded = true
      })
    },
  },
};
</script>
